import { SVGProps } from 'react';

const Nut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 4V2m0 2c4 0 7.5 2 8 4 .242.97.703 1.964 2 3-1.317.157-1.968-.084-3-1-.32 1.033-.791 1.452-2 2-1.338-.577-1.871-1.023-2.5-2-.638.942-1.19 1.379-2.5 2-1.349-.573-1.905-1.005-2.5-2-.546.902-1.048 1.353-2.5 2-1.018-.644-1.46-1.08-2-2-1.028.71-1.69.918-3 1 1.081-1.048 1.757-2.03 2-3 .5-2 4-4 8-4m-7 6v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592A7 7 0 0 0 19 14v-4"
    />
  </svg>
);
export default Nut;
